exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".wrap[data-v-e33815ce]{width:calc(100% - 2.5rem);height:31.06rem;margin-top:1rem;background:url(" + require("../../static/assets/tel_bg1.png") + ") no-repeat;background-size:100% 100%;padding:1.25rem}.wrap h5[data-v-e33815ce]{font-size:1.5rem;margin-bottom:1.25rem}.wrap p[data-v-e33815ce]{font-size:1rem;margin-bottom:.625rem}.content_top[data-v-e33815ce]{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;margin-bottom:1.25rem}.content_top section[data-v-e33815ce]{width:50%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-rewriter.js?id=data-v-e33815ce&scoped=true!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/tel.vue
// module id = 504
// module chunks = 0